var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMilitary = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 37 37",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.096 14.534v12.005l-7.028 6.471v-9.248l2.312-5.14v-4.986s-2.973 4.961-7.304 4.961-7.267-4.96-7.267-4.96v4.984l2.312 5.14v9.25l-6.938-6.472V14.534c0-6.11 5.802-11.063 11.912-11.063s12.002 4.953 12.002 11.063"
  })));
};
export default SvgMilitary;